import { showSessionExpiredDialog, logout } from '../store/slices/authSlice';

export const handleApiError = async (response, dispatch) => {
  let data;
  try {
    data = await response.json();
  } catch (e) {
    data = { message: 'Invalid server response' };
  }

  // Check for JWT expiration in both response status and error message
  const isJwtExpired = 
    response.status === 401 || 
    (data.message && (
      data.message.toLowerCase().includes('jwt expired') ||
      data.message.toLowerCase().includes('invalid token') ||
      data.message.toLowerCase().includes('unauthorized') ||
      data.message.toLowerCase().includes('token expired')
    ));

  if (isJwtExpired) {
    // Clear auth state and show session expired dialog
    dispatch(logout());
    dispatch(showSessionExpiredDialog());
    return { error: 'Session expired. Please login again.' };
  }

  return { error: data.message || `HTTP error! status: ${response.status}` };
};

export const handleThunkApiError = async (response, rejectWithValue, thunkAPI) => {
  const { error } = await handleApiError(response, thunkAPI.dispatch);
  return rejectWithValue(error);
};
